'use client';

import { useEffect } from 'react';
import styles from './atopia-viewer.module.scss';

const AtopiaViewer = ({ experienceId, useProduction }: IProps) => {
	const environment = useProduction ? 'prod' : 'dev';

	useEffect(() => {
		const container = document.getElementById('atopia-experience');
		if (!container) {
			return;
		}

		container.innerHTML = '';

		const script = document.createElement('script');
		script.src = 'https://static.atopia.space/embed-script/loader.js';
		script.async = true;
		script.dataset.containerId = 'atopia-experience';
		script.dataset.experienceId = experienceId;
		script.dataset.env = environment;
		script.dataset.width = '100%';
		script.dataset.height = '100%';
		container.parentElement?.appendChild(script);

		return () => {
			script.remove();
			container.innerHTML = '';
		};
	}, [environment, experienceId]);

	return <div id="atopia-experience" className={styles.atopiaExperience}></div>;
};

interface IProps {
	experienceId: string;
	useProduction?: boolean;
}

export default AtopiaViewer;
